import { Types } from '@store/types';

const initialState = { imageLoader: false, colorLoader: false };

const MoodboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_MOODBOARD_DETAILS:
			return { ...initialState, ...action.payload };
		case Types.SET_REUPLOADED_MOODBOARD_IMAGE: {
			let { docUrl, id } = action.payload;
			let moodboardImageList = state?.moodboardImageList?.map((item) => {
				if (item.id === id) {
					item.docUrl = docUrl;
				}
				return item;
			});
			return { ...state, moodboardImageList };
		}
		case Types.SET_UPLOAD_PRODUCT_IMAGE: {
			let productImageList = [...(state?.productImageList || []), ...action.payload];
			return { ...state, productImageList };
		}
		case Types.REMOVE_PRODUCT_IMAGE_FROM_MOODBOARD: {
			let { removedProductId } = action.payload;
			let previousImageList = state?.productImageList?.filter((item) => item.id !== removedProductId);
			return { ...state, productImageList: previousImageList };
		}
		case Types.ADD_FILE_TO_MOODBOARD: {
			let upLoadedFileList = [...(state?.moodboardImageList || []), ...action.payload];
			return { ...state, moodboardImageList: upLoadedFileList };
		}
		case Types.ADD_COLOR_TO_MOODBOARD: {
			let colorListAfterAdd = [...(state?.colorResponseList || []), action.payload];
			return { ...state, colorResponseList: colorListAfterAdd };
		}
		case Types.REMOVE_COLOR_FROM_MOODBOARD: {
			let removedColorId = action.payload;
			let colorListAfterRemove = state?.colorResponseList?.filter((item) => item.id !== removedColorId);
			return { ...state, colorResponseList: colorListAfterRemove };
		}
		case Types.ADD_FABRIC_TO_MOODBOARD: {
			let addedMaterials = [...(state?.materialResponseList || []), action.payload];
			return { ...state, materialResponseList: addedMaterials };
		}
		case Types.REMOVE_FABRIC_FROM_MOODBOARD: {
			let removedMaterialId = action.payload;
			let materialistAfterRemove = state?.materialResponseList?.filter(
				(item) => item.id !== removedMaterialId
			);
			return { ...state, materialResponseList: materialistAfterRemove };
		}
		case Types.ADD_COLORS_FROM_RESPONSE_TO_MOODBOARD:
			return { ...state, colorResponseList: action.payload };
		case Types.ADD_IMAGES_FROM_RESPONSE_TO_MOODBOARD:
			return { ...state, productImageList: action.payload };
		case Types.MOODBOARD_IMAGE_LOADING_START:
			return { ...state, imageLoader: true };
		case Types.MOODBOARD_IMAGE_LOADING_CLOSE:
			return { ...state, imageLoader: false };
		case Types.MOODBOARD_COLOR_LOADING_START:
			return { ...state, colorLoader: true };
		case Types.MOODBOARD_COLOR_LOADING_CLOSE:
			return { ...state, colorLoader: false };
		default:
			return state;
	}
};

export default MoodboardReducer;
